module.exports = __webpack_public_path__ + "static/sharsoom-59ac143bfd9969e42e594a480085ed17.jpeg";